<i18n>
{
  "fr": {
    "copy-success": "Le lien a été copié dans votre presse-papier.",
    "copy-failure": "Oups! Le lien n'a pas pu être copié."
  },
  "en": {
    "copy-success": "The link has been copied into your clipboard.",
    "copy-failure": "Oops! The link couldn't be copied."
  }
}
</i18n>

<template>
  <span style="text-decoration: underline">
    <i class="fas fa-link pr-8px" style="font-size: 90%" />
    <a v-if="canClick" :href="link" class="has-text-link" target="_blank">{{ link }}</a>
    <span v-else @click="copyLink" class="has-text-link" style="cursor: pointer">{{ link }}</span>
  </span>
</template>
<script>
import { copyTextToClipboard } from '@/helpers/clipboard'
import Notification from '@/services/notification'

/* Tous les liens débutant par "XYZ:/", "XYZ:\" ou "\\"
 * Note: Chrome ne permet pas de cliquer sur un lien vers un fichier local */
// const clickableRegexes = [/^[a-z]+:[\\/]/, /^\\\\./]

// Seulement les liens web
const clickableRegexes = [/^https?:\/\//]

export default {
  props: {
    link: String
  },
  computed: {
    canClick() {
      return clickableRegexes.some((r) => r.test(this.link))
    }
  },
  methods: {
    async copyLink() {
      if (await copyTextToClipboard(this.link)) {
        Notification.showSuccess(this.$t('copy-success'))
      } else {
        Notification.showWarning(this.$t('copy-failure'))
      }
    }
  }
}
</script>